import React from 'react'
import { ISocialPlatform } from '@/interfaces/socials'

// styles
import { cssClass } from '@/shared/utils/styles'
import { IMAGE_PATHS_V2 } from '@/shared/consts/imagesPaths'
import Image from 'next/image'
import { socialIconLinkContainerGray } from './styles/styles.css'
import { skeleton } from '../skeleton/styles/index.css'
import { Tooltip } from '@mantine/core'

type BaseProps = {
  social: ISocialPlatform | 'web'
  filterGray?: boolean
  size?: number
  alt?: string
  onClick?: (platform: ISocialPlatform | 'web') => void
  isLoading?: boolean
  withTooltip?: boolean
}

export const SocialIconButtonWithWeb: React.FC<BaseProps> = (props) => {
  const {
    social,
    filterGray = false,
    size = 32,
    onClick,
    alt = 'social_icon',
    isLoading = false,
    withTooltip = true,
  } = props

  const [loaded, setLoaded] = React.useState(false)

  const url =
    social !== 'web'
      ? IMAGE_PATHS_V2.icons.socials +
        (filterGray ? `${social}-gray-icon.png` : `${social}-icon.png`)
      : IMAGE_PATHS_V2.icons.socials +
        (filterGray ? 'website-gray-icon.png' : 'website-icon.png')

  if (withTooltip) {
    return (
      <Tooltip label={social}>
        <div
          onClick={() => onClick && onClick(social)}
          style={{ width: size, aspectRatio: '1/1', borderRadius: '50%' }}
          className={cssClass([
            'flex justify-center items-center relative cursor-pointer',
            filterGray && socialIconLinkContainerGray,
            skeleton,
          ])}
        >
          {!isLoading && (
            <Image
              src={url}
              alt={`${alt}_${social}`}
              sizes={`${size + 2}px`}
              fill
              onLoad={() => setLoaded(true)}
              className={loaded ? 'opacity-100' : 'opacity-0'}
            />
          )}
        </div>
      </Tooltip>
    )
  }

  return (
    <div
      onClick={() => onClick && onClick(social)}
      style={{ width: size, aspectRatio: '1/1', borderRadius: '50%' }}
      className={cssClass([
        'flex justify-center items-center relative cursor-pointer',
        filterGray && socialIconLinkContainerGray,
        skeleton,
      ])}
    >
      {!isLoading && (
        <Image
          src={url}
          alt={`${alt}_${social}`}
          sizes={`${size + 2}px`}
          fill
          onLoad={() => setLoaded(true)}
          className={loaded ? 'opacity-100' : 'opacity-0'}
        />
      )}
    </div>
  )
}
